import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { hairAnalyserMessages } from '../messages';
import { StyledDescription } from '../styled';

interface DescriptionProps {
  brandName: string;
}

export const Description: React.FC<DescriptionProps> = ({ brandName }) => (
  <StyledDescription>
    <FormattedMessage
      {...hairAnalyserMessages.hairAnalyserDescriptionVariant}
      values={{ brandName }}
    />
  </StyledDescription>
);
